import React from 'react';
import { Selection } from './types';
import { formatCurrency } from '../../../../../utils/functions';
import './RenderSelections.scss';
import { FaX } from 'react-icons/fa6';

interface OrderDisplayerProps {
  selections: Selection[];
  showTotal: boolean; // Nuevo prop
}

const RenderSelections: React.FC<OrderDisplayerProps> = ({ selections, showTotal }) => {
  // Ensure selections is an array, default to empty array if undefined
  const safeSelections = selections || [];
  
  // Calcular el total
  const grandTotal = safeSelections.reduce((sum, sel) => sum + sel.total_price, 0);

  return (
    <div className="order-displayer">
      <ul className="selections-list">
        {safeSelections.map((sel) => (
          <li key={sel.selection_id} className="selection-item">
            <div className="main-row">
              {/* Cantidad */}
              <div className="quantity-name-display">
                <span className="selection-quantity"> {sel.quantity} <FaX size={10}/></span>
                <span className="selection-name">{sel.item_name}</span>
                <div className="selection-price">
                  {formatCurrency(sel.total_price)}
                </div>
              </div>

              {/* Cliente 
              <div className="client-display">
                {sel.clientIndex === -1 ? 'Grupo' : `Cliente ${sel.clientIndex + 1}`}
              </div>
                */}
              {/* Precio */}


              {/* Información del ítem */}
              <div className="item-info">
                {(sel.selection_groups.length > 0 || sel.modifiers.length > 0) && (
                  <span className="concise-details">
                    {sel.selection_groups.length > 0 &&
                      sel.selection_groups
                        .flatMap((sg) =>
                          sg.selected_items.map((sgi) => sgi.item_name)
                        )
                        .join(', ')}
                    {sel.selection_groups.length > 0 && sel.modifiers.length > 0 && ', '}
                    {sel.modifiers.length > 0 &&
                      sel.modifiers.map((mod) => mod.option_name).join(', ')}
                  </span>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>

      {/* Mostrar el total solo si showTotal es true */}
      {showTotal && (
        <div className="grand-total">
          <span>Total: 
            <span className='total'>{formatCurrency(grandTotal)}</span>
          </span>
        </div>
      )}
    </div>
  );
};

export default RenderSelections;
